import BillingsOrderForwardTaxiTaxiRecalculateResponse, {
  BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType,
  BillingsOrderForwardTaxiTaxiRecalculateResponseDataContribution,
  BillingsOrderForwardTaxiTaxiRecalculateResponseDataNode,
  BillingsOrderForwardTaxiTaxiRecalculateResponseOrderForwardingActionContractBillingModel,
  BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionContractTaxiDetails,
  BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionContract,
  BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionTransportingOrderCargoOrder,
  BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionTransportingOrder,
  BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingAction,
  BillingsOrderForwardTaxiTaxiRecalculateResponseDataStatus,
  BillingsOrderForwardTaxiTaxiRecalculateResponseData,
} from "../../../../../api/raily/billings/order-forward/taxi-taxi/recalculate/billings-order-forward-taxi-taxi-recalculate.response";
import BillingModel from "../../../../../types/billing-model";
import BillingStatus from "../../../../../types/billing-status";
import BillingsOrderForwardTaxiTaxiRecalculate, {
  BillingsOrderForwardTaxiTaxiRecalculateContribution,
  BillingsOrderForwardTaxiTaxiRecalculateContributionType,
  BillingsOrderForwardTaxiTaxiRecalculateNode,
  BillingsOrderForwardTaxiTaxiRecalculateAction,
  BillingsOrderForwardTaxiTaxiRecalculateActionContract,
  BillingsOrderForwardTaxiTaxiRecalculateActionContractTaxiRecalculate,
  BillingsOrderForwardTaxiTaxiRecalculateActionTransportingOrder,
  BillingsOrderForwardTaxiTaxiRecalculateActionTransportingOrderCargoOrder,
} from "./billings-order-forward-taxi-taxi-recalculate";

const createContributionType = (
  type:
    | BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.BONUS_OTHER
    | BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_WRONG_ROUTE
    | BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_BEING_LATE
    | BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_INCOMPATIBLE_CAR
    | BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_OTHER,
):
  | BillingsOrderForwardTaxiTaxiRecalculateContributionType.BONUS_OTHER
  | BillingsOrderForwardTaxiTaxiRecalculateContributionType.PENALTY_WRONG_ROUTE
  | BillingsOrderForwardTaxiTaxiRecalculateContributionType.PENALTY_BEING_LATE
  | BillingsOrderForwardTaxiTaxiRecalculateContributionType.PENALTY_INCOMPATIBLE_CAR
  | BillingsOrderForwardTaxiTaxiRecalculateContributionType.PENALTY_OTHER => {
  switch (type) {
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.BONUS_OTHER:
      return BillingsOrderForwardTaxiTaxiRecalculateContributionType.BONUS_OTHER;
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_WRONG_ROUTE:
      return BillingsOrderForwardTaxiTaxiRecalculateContributionType.PENALTY_WRONG_ROUTE;
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_BEING_LATE:
      return BillingsOrderForwardTaxiTaxiRecalculateContributionType.PENALTY_BEING_LATE;
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_INCOMPATIBLE_CAR:
      return BillingsOrderForwardTaxiTaxiRecalculateContributionType.PENALTY_INCOMPATIBLE_CAR;
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_OTHER:
      return BillingsOrderForwardTaxiTaxiRecalculateContributionType.PENALTY_OTHER;
  }
};

const createContribution = (
  contribution: BillingsOrderForwardTaxiTaxiRecalculateResponseDataContribution,
): BillingsOrderForwardTaxiTaxiRecalculateContribution => {
  switch (contribution.type) {
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.BONUS_FAVORABLE_DISTANCE:
      return {
        type: BillingsOrderForwardTaxiTaxiRecalculateContributionType.BONUS_FAVORABLE_DISTANCE,
        comment: contribution.comment,
        distance: contribution.distance,
        rate: contribution.rate,
      };
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.BONUS_OTHER:
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_BEING_LATE:
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_INCOMPATIBLE_CAR:
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_OTHER:
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataContributionType.PENALTY_WRONG_ROUTE:
      return {
        type: createContributionType(contribution.type),
        comment: contribution.comment,
        amount: contribution.amount,
      };
  }
};

const createContributions = (
  contributions: BillingsOrderForwardTaxiTaxiRecalculateResponseDataContribution[],
): BillingsOrderForwardTaxiTaxiRecalculateContribution[] => {
  return contributions
    .map(createContribution)
    .filter((contribution) => contribution);
};

const createNode = (
  node: BillingsOrderForwardTaxiTaxiRecalculateResponseDataNode,
): BillingsOrderForwardTaxiTaxiRecalculateNode => {
  return {
    allowCharge: node.allowCharge,
    checkoutDate: node.checkoutDate,
    checkoutEventUuid: node.checkoutEventId,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingAmount: node.haltingAmount,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    lat: node.lat,
    lon: node.lon,
    nodeUuid: node.nodeId,
    orderUuid: node.orderId,
    plannedDate: node.plannedDate,
    plannedDistance: node.plannedDistance,
    uuid: node.id,
  };
};

const createNodes = (
  nodes: BillingsOrderForwardTaxiTaxiRecalculateResponseDataNode[],
): BillingsOrderForwardTaxiTaxiRecalculateNode[] => {
  return nodes.map(createNode);
};

const createModel = (
  model: BillingsOrderForwardTaxiTaxiRecalculateResponseOrderForwardingActionContractBillingModel,
): BillingModel => {
  switch (model) {
    case BillingsOrderForwardTaxiTaxiRecalculateResponseOrderForwardingActionContractBillingModel.AB:
      return BillingModel.AB;
    case BillingsOrderForwardTaxiTaxiRecalculateResponseOrderForwardingActionContractBillingModel.ABA:
      return BillingModel.ABA;
    case BillingsOrderForwardTaxiTaxiRecalculateResponseOrderForwardingActionContractBillingModel.OTHER:
      return BillingModel.OTHER;
    case BillingsOrderForwardTaxiTaxiRecalculateResponseOrderForwardingActionContractBillingModel.SABS:
      return BillingModel.SABS;
  }
};

const createTaxi = (
  taxi: BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionContractTaxiDetails,
): BillingsOrderForwardTaxiTaxiRecalculateActionContractTaxiRecalculate => {
  return {
    displayName: taxi.displayName,
  };
};

const createContract = (
  contract: BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionContract,
): BillingsOrderForwardTaxiTaxiRecalculateActionContract => {
  return {
    distanceRate: contract.distanceRate,
    haltingTimeAfterMinutes: contract.haltingTimeAfterMinutes,
    haltingTimeRate: contract.haltingTimeRate,
    model: createModel(contract.model),
    producerTaxi: createTaxi(contract.producerTaxi),
  };
};

const createCargoOrder = (
  cargo: BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionTransportingOrderCargoOrder,
): BillingsOrderForwardTaxiTaxiRecalculateActionTransportingOrderCargoOrder => {
  return {
    humanId: cargo.humanId,
    uuid: cargo.id,
  };
};

const createTransportingOrder = (
  transportingOrder: BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingActionTransportingOrder,
): BillingsOrderForwardTaxiTaxiRecalculateActionTransportingOrder => {
  return {
    cargoOrder: createCargoOrder(transportingOrder.cargoOrder),
  };
};

const createForwardingAction = (
  action: BillingsOrderForwardTaxiTaxiRecalculateResponseDataOrderForwardingAction,
): BillingsOrderForwardTaxiTaxiRecalculateAction => {
  return {
    contract: createContract(action.contract),
    transportingOrder: createTransportingOrder(action.transportingOrder),
    uuid: action.id,
  };
};

const createStatus = (
  status: BillingsOrderForwardTaxiTaxiRecalculateResponseDataStatus,
): BillingStatus => {
  switch (status) {
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataStatus.ACCEPTED:
      return BillingStatus.ACCEPTED;
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataStatus.CREATED:
      return BillingStatus.CREATED;
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataStatus.REJECTED:
      return BillingStatus.REJECTED;
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataStatus.REOPENED:
      return BillingStatus.REOPENED;
    case BillingsOrderForwardTaxiTaxiRecalculateResponseDataStatus.REOPEN_REQUEST:
      return BillingStatus.REOPEN_REQUEST;
  }
};

const createData = (
  data: BillingsOrderForwardTaxiTaxiRecalculateResponseData,
): BillingsOrderForwardTaxiTaxiRecalculate => {
  return {
    allContributionsAmount: data.allContributionsAmount,
    amountForChargeHaltings: data.amountForChargeHaltings,
    amountForChargeHighways: data.amountForChargeHighways,
    amountForDistance: data.amountForDistance,
    billingContributions: createContributions(data.billingContributions),
    billingNodes: createNodes(data.billingNodes),
    date: data.date,
    distance: data.distance,
    orderForwardingAction: createForwardingAction(data.orderForwardingAction),
    passengers: data.passengers,
    planEntryUuid: data.planEntryId,
    status: createStatus(data.status),
    sumOfBonuses: data.sumOfBonuses,
    sumOfPenalties: data.sumOfPenalties,
  };
};

const create = (
  response: BillingsOrderForwardTaxiTaxiRecalculateResponse,
): BillingsOrderForwardTaxiTaxiRecalculate => {
  return createData(response.data);
};

const billingsOrderForwardTaxiTaxiRecalculateFactory = {
  create,
};

export default billingsOrderForwardTaxiTaxiRecalculateFactory;
